import { render, staticRenderFns } from "./UpdatePerformanceReportVersionPage.vue?vue&type=template&id=51ab1d16&scoped=true"
import script from "./UpdatePerformanceReportVersionPage.vue?vue&type=script&lang=js"
export * from "./UpdatePerformanceReportVersionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ab1d16",
  null
  
)

export default component.exports